import {EventEmitter} from 'events';
import AppDispatcher from '../app/AppDispatcher';

export default function(definition) {
  const store = Object.assign(
    {},
    EventEmitter.prototype,
    {
      addChangeListener(callback) {
        this.on('change', callback);
      },

      removeChangeListener(callback) {
        this.removeListener('change', callback);
      },

      hasChanged() {
        this.emit('change');
      },

      unregister() {
        AppDispatcher.unregister(store.dispatcher);
      },

      // Explicitly in here in the case a store wants to override how events are handled
      __process(payload) {
        const action = payload.action;
        for (const method in store.handlers) {
          if (store.handlers[method] === action.type) {
            store[method](action);
          }
        }
      },
    },
    definition
  );

  store.dispatcher = AppDispatcher.register(payload => {
    store.__process(payload);
  });

  return store;
}
